module.exports = __webpack_public_path__ + "img/arrow_right_2.5cfedd4f.svg";